export const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      servicesFisica: "Terapia Física",
      servicesQuiro: "Quiropráctica",
      alternative: "Terapias Alternativas",
      estetica: "Tratamientos Estéticos",
      about: "Nosotros",
      team: "Equipo",
      blog: "Blog",
      booking: "Agendar",
      contact: "Contacto",
      cta: "Agendar cita",
    },
    hero: {
      eyebrow: "Terapia física · Quiropráctica · Rehabilitación",
      title1: "Al cuidado",
      title2: "de tu cuerpo",
      desc: "En TERAFIQUIRO combinamos ciencia, manos expertas y un enfoque integral para devolverte movilidad, equilibrio y bienestar. Sin dolor, con confianza.",
      location: "Quiropráctico y terapia física",
      cta1: "Agendar cita",
      cta2: "Hablar por WhatsApp",
      stat1: "+10 años",
      stat1Sub: "de experiencia clínica",
      stat2: "+2,500",
      stat2Sub: "pacientes atendidos",
      stat3: "98%",
      stat3Sub: "recomendación",
    },
    services: {
      eyebrow: "Fisioterapia y Quiropráctica",
      title: "Fisioterapia y Quiropráctica",
      desc: "Tratamiento clínico integral para reducir el dolor, restaurar movilidad y prevenir nuevas lesiones. Combinamos terapia física, rehabilitación y quiropráctica en un solo plan personalizado para ti.",
      cta: "Agendar fisioterapia o quiropráctica",
      benefitsTitle: "Beneficios",
      benefits: [
        "Alivio del dolor y la inflamación desde las primeras sesiones.",
        "Recuperación de movilidad, fuerza y equilibrio.",
        "Prevención de recaídas y mejora de tu rendimiento físico.",
      ],
      fisica: {
        name: "Terapia Física",
        desc: "Técnicas y rehabilitación clínica para acelerar tu recuperación.",
        techTitle: "Técnicas",
        techniques: [
          "Termoterapia",
          "Crioterapia",
          "Vendaje neuromuscular (Kinesiotape)",
          "Aplicación de ultrasonido",
          "Aplicación de láser",
          "Ejercicios terapéuticos",
          "Corrección de marcha y postura",
          "Propiocepción y equilibrio",
          "Mejora de arcos de movilidad",
          "Fortalecimiento muscular",
        ],
        condTitle: "Padecimientos que tratamos",
        conditions: [
          "Lumbalgia (dolor de espalda baja)",
          "Cervicalgia (dolor de cuello)",
          "Tendinitis y bursitis",
          "Esguinces y desgarros musculares",
          "Recuperación post-fractura",
          "Rehabilitación post-quirúrgica",
          "Síndrome del túnel carpiano",
          "Hombro congelado (capsulitis adhesiva)",
          "Epicondilitis (codo de tenista/golfista)",
          "Fascitis plantar",
          "Lesiones deportivas",
          "Contracturas y tortícolis",
        ],
      },
      quiro: {
        name: "Quiropráctica",
        desc: "Ajustes manuales precisos para devolver el equilibrio a tu columna y articulaciones.",
        techTitle: "Técnicas",
        techniques: [
          "Exploración quirofísica",
          "Manipulaciones articulares",
          "Ajustes vertebrales (técnica Diversified)",
          "Masaje terapéutico",
          "Movilizaciones articulares",
          "Liberación miofascial",
        ],
        condTitle: "Padecimientos que tratamos",
        conditions: [
          "Ciática y dolor lumbar",
          "Dolor cervical y tortícolis",
          "Migrañas y cefaleas tensionales",
          "Hernias discales (lumbares y cervicales)",
          "Vértigo y mareos cervicogénicos",
          "Bloqueos articulares",
          "Escoliosis funcional y mala postura",
          "Dolor de hombro y rotadores",
          "Síndrome del piriforme",
          "Dolor sacroilíaco",
          "Problemas de ATM (mandíbula)",
          "Dolor de cadera y rodilla",
        ],
      },
    },
    bookingFisio: {
      eyebrow: "Agenda · Fisioterapia y Quiropráctica",
      title: "Reserva tu sesión de fisioterapia o quiropráctica",
      desc: "Elige fecha y horario para tu sesión de terapia física, rehabilitación o ajuste quiropráctico. Confirmamos por WhatsApp.",
    },
    about: {
      eyebrow: "Sobre nosotros",
      title: "Un equipo apasionado por tu bienestar",
      welcome: "Agradecemos tu visita y será un placer conocerte y servirte profesionalmente en nuestro consultorio.",
      p1: "TERAFIQUIRO nace con la convicción de que cada cuerpo merece atención humana, técnica y empática. Combinamos terapia física, rehabilitación y quiropráctica en un solo espacio para ofrecerte un tratamiento verdaderamente integral.",
      p2: "Trabajamos con tecnología actual, evidencia clínica y un trato cercano. Cada sesión se diseña para ti: con objetivos claros y un acompañamiento constante hasta lograr tu recuperación.",
      bullets: [
        "Diagnóstico personalizado en tu primera visita",
        "Planes terapéuticos basados en evidencia",
        "Instalaciones cómodas y modernas",
        "Seguimiento continuo de tu progreso",
      ],
    },
    testimonials: {
      eyebrow: "Lo que dicen nuestros pacientes",
      title: "Historias reales de recuperación",
    },
    booking: {
      eyebrow: "Agenda en línea",
      title: "Reserva tu cita en segundos",
      desc: "Selecciona la fecha, el servicio y el horario que mejor se adapte a ti. Confirmamos tu cita por WhatsApp.",
      name: "Nombre completo",
      phone: "Teléfono",
      email: "Correo electrónico (opcional)",
      service: "Servicio",
      selectService: "Selecciona un servicio",
      date: "Fecha de la cita",
      time: "Horario",
      notes: "Notas (opcional)",
      notesPlaceholder: "Cuéntanos brevemente tu motivo de consulta...",
      submit: "Confirmar cita",
      submitting: "Enviando...",
      successTitle: "¡Cita agendada!",
      successDesc: "Te contactaremos por WhatsApp para confirmar.",
      errorTitle: "No se pudo agendar",
      errorDesc: "Revisa los datos e intenta de nuevo.",
      pickDate: "Elige una fecha",
      services: {
        terapia_fisica: "Terapia Física",
        rehabilitacion: "Rehabilitación",
        quiropractica: "Quiropráctica",
        terapias_alternativas: "Terapias Alternativas",
        estetica: "Estética facial y corporal",
        consulta_general: "Consulta general",
      },
    },
    bookingAlt: {
      eyebrow: "Agenda · Terapias Alternativas",
      title: "Reserva tu sesión de terapia alternativa",
      desc: "Elige fecha y horario para tu sesión de ozonoterapia, punción seca, terapia neural, herbolaria, reflexología, ventosas u otras técnicas complementarias.",
    },
    bookingEstetica: {
      eyebrow: "Agenda · Estética facial y corporal",
      title: "Reserva tu tratamiento estético",
      desc: "Faciales antiedad, lifting, tratamientos para acné, despigmentantes, hidratación profunda y lifting de pestañas. Reserva tu hora preferida.",
    },
    alternative: {
      eyebrow: "Terapias Alternativas",
      title: "Equilibrio integral cuerpo y mente",
      desc: "Técnicas complementarias que potencian la recuperación, equilibran tu energía y mejoran tu calidad de vida. Cada sesión se adapta a tu necesidad clínica.",
      itemsTitle: "Técnicas que ofrecemos",
      items: [
        "Ozonoterapia",
        "Punción seca",
        "Terapia neural",
        "Herbolaria",
        "Reflexología",
        "Ventosas (cupping)",
        "Otras técnicas complementarias",
      ],
      benefitsTitle: "Beneficios",
      benefits: [
        "Alivio del estrés, ansiedad e insomnio.",
        "Estimulación del sistema inmune y equilibrio energético.",
        "Apoyo en el tratamiento de enfermedades sistémicas y crónico degenerativas.",
      ],
      cta: "Agendar terapia alternativa",
    },
    estetica: {
      eyebrow: "Estética facial y corporal",
      title: "Tu mejor versión empieza en tu piel",
      desc: "Tratamientos cosméticos y estéticos basados en evidencia para revelar una piel sana, luminosa y equilibrada en cualquier etapa de la vida.",
      itemsTitle: "Tratamientos",
      items: [
        "Faciales antiedad",
        "Efecto lifting",
        "Tratamientos para acné, secuelas de acné y despigmentantes",
        "Faciales hidratantes para pieles secas y/o sensibles",
        "Lifting de pestañas",
      ],
      benefitsTitle: "Beneficios",
      benefits: [
        "Una piel sana actúa como una barrera protectora contra bacterias y sustancias químicas.",
        "Una rutina de cuidado reduce el riesgo de acné, puntos negros, resequedad, irritación y envejecimiento prematuro.",
        "Una piel hidratada y limpia luce más suave, radiante y saludable.",
      ],
      cta: "Agendar tratamiento estético",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Estamos para escucharte",
      desc: "Escríbenos un mensaje o contáctanos directamente por WhatsApp. Te responderemos lo antes posible.",
      address: "Calle El Pípila 200, Colonia Centro, Pachuca de Soto, Hidalgo, México",
      hoursTitle: "Horarios",
      hours: "Lun–Vie 9:00–19:00 · Sáb 9:00–14:00",
      whatsapp: "WhatsApp directo",
      send: "Enviar mensaje",
      sending: "Enviando...",
      msgName: "Tu nombre",
      msgEmail: "Tu correo",
      msgPhone: "Tu teléfono",
      msgMessage: "Tu mensaje",
      sentTitle: "Mensaje enviado",
      sentDesc: "Gracias por escribirnos.",
    },
    footer: {
      tag: "Al cuidado de tu cuerpo",
      copy: "Todos los derechos reservados.",
    },
    fab: {
      whatsapp: "Hablar por WhatsApp",
    },
    specialties: {
      eyebrow: "Padecimientos que tratamos",
      title: "Atención clínica para tu motivo de consulta",
      desc: "Combinamos quiropráctica, terapia física, rehabilitación y terapias alternativas para resolver de raíz las causas más comunes de dolor y limitación funcional.",
      items: [
        { name: "Ciática", img: "/img/specialties/01_ciatica.png" },
        { name: "Dolor de espalda", img: "/img/specialties/02_dolor_espalda.png" },
        { name: "Dolor de cadera", img: "/img/specialties/03_dolor_cadera.png" },
        { name: "Dolor de rodilla", img: "/img/specialties/04_dolor_rodilla.png" },
        { name: "Lesión deportiva", img: "/img/specialties/05_lesion_deportiva.png" },
        { name: "Terapias para deportistas", img: "/img/specialties/06_terapias_deportistas.png" },
        { name: "Masaje de descarga", img: "/img/specialties/07_masaje_descarga.png" },
        { name: "Masaje corporal", img: "/img/specialties/08_masaje_corporal.png" },
        { name: "Masaje facial", img: "/img/specialties/09_masaje_facial.png" },
        { name: "Huesero · Ajustes quiroprácticos", img: "/img/specialties/10_huesero_quiropractica.png" },
        { name: "Ozonoterapia", img: "/img/specialties/11_ozonoterapia.png" },
        { name: "Punción seca", img: "/img/specialties/12_puncion_seca.png" },
        { name: "Terapia neural", img: "/img/specialties/13_terapia_neural.png" },
        { name: "Herbolaria · Adaptógenos", img: "/img/specialties/14_herbolaria.png" },
        { name: "Reflexología", img: "/img/specialties/15_reflexologia.png" },
        { name: "Ventosas (cupping)", img: "/img/specialties/16_ventosas_cupping.png" },
        { name: "Mesoterapia facial", img: "/img/specialties/09_masaje_facial.png" },
        { name: "Medicina funcional", img: "/img/specialties/14_herbolaria.png" },
      ],
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Resolvemos tus dudas antes de tu primera visita",
      items: [
        {
          q: "¿Atienden ciática y dolor de espalda?",
          a: "Sí. Tratamos ciática, dolor lumbar, dolor de espalda, cadera y rodilla mediante terapia física, ajustes quiroprácticos (huesero) y rehabilitación. Iniciamos con una valoración integral y diseñamos tu plan terapéutico.",
        },
        {
          q: "¿Tienen tratamientos especializados para deportistas?",
          a: "Sí. Manejamos lesión deportiva con masaje de descarga, vendaje neuromuscular, punción seca, terapia neural y planes de rehabilitación específicos por deporte para volver a competir más fuerte.",
        },
        {
          q: "¿En qué consisten las terapias alternativas?",
          a: "Ofrecemos ozonoterapia, punción seca, terapia neural, herbolaria, adaptógenos, reflexología y ventosas (cupping) como apoyo a tratamientos clínicos y para mejorar tu calidad de vida.",
        },
        {
          q: "¿Cuál es la diferencia entre quiropráctico y huesero?",
          a: "El término popular 'huesero' hace referencia a ajustes manuales. En TERAFIQUIRO realizamos quiropráctica clínica: exploración quirofísica, manipulaciones articulares precisas y masaje terapéutico, siempre fundamentado en evidencia.",
        },
        {
          q: "¿Dónde están ubicados?",
          a: "Estamos en Pachuca de Soto, Hidalgo, México. Puedes agendar tu cita en línea desde el sitio o por WhatsApp: Fisioterapia/Quiropráctica +52 771 214 1634, Terapias Alternativas +52 771 161 0609, Estética +52 771 129 0073.",
        },
        {
          q: "¿Qué incluye la estética facial?",
          a: "Faciales antiedad, efecto lifting, tratamientos para acné y secuelas de acné, despigmentantes, faciales hidratantes para pieles secas o sensibles y lifting de pestañas. Cuidamos tu piel con técnica y productos profesionales.",
        },
      ],
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      servicesFisica: "Physical Therapy",
      servicesQuiro: "Chiropractic",
      alternative: "Alternative Therapies",
      estetica: "Aesthetic Treatments",
      about: "About",
      team: "Team",
      blog: "Blog",
      booking: "Booking",
      contact: "Contact",
      cta: "Book a visit",
    },
    hero: {
      eyebrow: "Physical therapy · Chiropractic · Rehab",
      title1: "Caring for",
      title2: "your body",
      desc: "At TERAFIQUIRO we blend science, expert hands and an integrative approach to bring back your mobility, balance and well-being. Pain-free, with confidence.",
      location: "Chiropractor and physical therapy",
      cta1: "Book a visit",
      cta2: "Chat on WhatsApp",
      stat1: "10+ years",
      stat1Sub: "of clinical practice",
      stat2: "2,500+",
      stat2Sub: "patients treated",
      stat3: "98%",
      stat3Sub: "would recommend us",
    },
    services: {
      eyebrow: "Physical Therapy & Chiropractic",
      title: "Physical Therapy & Chiropractic",
      desc: "Integrative clinical treatment to relieve pain, restore mobility and prevent new injuries. We blend physical therapy, rehab and chiropractic into one personalized plan.",
      cta: "Book physical therapy or chiropractic",
      benefitsTitle: "Benefits",
      benefits: [
        "Pain and inflammation relief from the first sessions.",
        "Recovery of mobility, strength and balance.",
        "Relapse prevention and improved physical performance.",
      ],
      fisica: {
        name: "Physical Therapy",
        desc: "Clinical techniques and rehabilitation to speed up your recovery.",
        techTitle: "Techniques",
        techniques: [
          "Thermotherapy",
          "Cryotherapy",
          "Kinesiotaping",
          "Ultrasound therapy",
          "Laser therapy",
          "Therapeutic exercises",
          "Gait & posture correction",
          "Proprioception & balance",
          "Mobility improvement",
          "Muscle strengthening",
        ],
        condTitle: "Conditions we treat",
        conditions: [
          "Lower back pain (lumbalgia)",
          "Neck pain (cervicalgia)",
          "Tendinitis and bursitis",
          "Sprains and muscle tears",
          "Post-fracture recovery",
          "Post-surgical rehabilitation",
          "Carpal tunnel syndrome",
          "Frozen shoulder",
          "Tennis/golfer's elbow",
          "Plantar fasciitis",
          "Sports injuries",
          "Muscle contractures and torticollis",
        ],
      },
      quiro: {
        name: "Chiropractic",
        desc: "Precise manual adjustments to restore the balance of your spine and joints.",
        techTitle: "Techniques",
        techniques: [
          "Chiropractic assessment",
          "Joint manipulations",
          "Vertebral adjustments (Diversified technique)",
          "Therapeutic massage",
          "Joint mobilizations",
          "Myofascial release",
        ],
        condTitle: "Conditions we treat",
        conditions: [
          "Sciatica and lower back pain",
          "Neck pain and torticollis",
          "Migraines and tension headaches",
          "Disc herniations (lumbar & cervical)",
          "Cervicogenic vertigo and dizziness",
          "Joint blockages",
          "Functional scoliosis and poor posture",
          "Shoulder and rotator cuff pain",
          "Piriformis syndrome",
          "Sacroiliac pain",
          "TMJ disorders",
          "Hip and knee pain",
        ],
      },
    },
    bookingFisio: {
      eyebrow: "Booking · Physical Therapy & Chiropractic",
      title: "Book your physical therapy or chiropractic session",
      desc: "Pick the date and time for your physical therapy, rehab or chiropractic adjustment. We confirm by WhatsApp.",
    },
    about: {
      eyebrow: "About us",
      title: "A team passionate about your well-being",
      welcome: "Thank you for visiting us. It will be our pleasure to meet you and serve you professionally at our practice.",
      p1: "TERAFIQUIRO was born from the belief that every body deserves human, technical, empathetic care. We blend physical therapy, rehab and chiropractic under one roof for a truly integrative treatment.",
      p2: "We use modern technology, clinical evidence and a close relationship with our patients. Every session is tailor-made with clear goals and constant support until you fully recover.",
      bullets: [
        "Personalized diagnosis at first visit",
        "Evidence-based therapy plans",
        "Comfortable, modern facilities",
        "Continuous follow-up of your progress",
      ],
    },
    testimonials: {
      eyebrow: "What our patients say",
      title: "Real recovery stories",
    },
    booking: {
      eyebrow: "Online booking",
      title: "Book your visit in seconds",
      desc: "Pick the date, the service and the time that fits you best. We confirm your appointment via WhatsApp.",
      name: "Full name",
      phone: "Phone",
      email: "Email (optional)",
      service: "Service",
      selectService: "Select a service",
      date: "Appointment date",
      time: "Time",
      notes: "Notes (optional)",
      notesPlaceholder: "Briefly tell us your reason for consultation...",
      submit: "Confirm appointment",
      submitting: "Sending...",
      successTitle: "Appointment booked!",
      successDesc: "We'll contact you on WhatsApp to confirm.",
      errorTitle: "Couldn't book",
      errorDesc: "Check the details and try again.",
      pickDate: "Pick a date",
      services: {
        terapia_fisica: "Physical Therapy",
        rehabilitacion: "Rehabilitation",
        quiropractica: "Chiropractic",
        terapias_alternativas: "Alternative Therapies",
        estetica: "Facial & Body Aesthetics",
        consulta_general: "General consultation",
      },
    },
    bookingAlt: {
      eyebrow: "Booking · Alternative Therapies",
      title: "Book your alternative therapy session",
      desc: "Pick a date and time for ozone therapy, dry needling, neural therapy, herbalism, reflexology, cupping or other complementary techniques.",
    },
    bookingEstetica: {
      eyebrow: "Booking · Facial & Body Aesthetics",
      title: "Book your aesthetic treatment",
      desc: "Anti-aging facials, lifting effect, acne and pigmentation treatments, deep hydration and lash lift. Reserve your preferred slot.",
    },
    alternative: {
      eyebrow: "Alternative Therapies",
      title: "Whole-body and mind balance",
      desc: "Complementary techniques that boost recovery, balance your energy and improve your quality of life. Every session is adapted to your clinical needs.",
      itemsTitle: "Techniques we offer",
      items: [
        "Ozone therapy",
        "Dry needling",
        "Neural therapy",
        "Herbalism",
        "Reflexology",
        "Cupping",
        "Other complementary techniques",
      ],
      benefitsTitle: "Benefits",
      benefits: [
        "Relief from stress, anxiety and insomnia.",
        "Immune system stimulation and energetic balance.",
        "Support for systemic and chronic degenerative conditions.",
      ],
      cta: "Book an alternative therapy",
    },
    estetica: {
      eyebrow: "Facial & Body Aesthetics",
      title: "Your best version starts with your skin",
      desc: "Evidence-based cosmetic and aesthetic treatments to reveal healthy, glowing and balanced skin at any stage of life.",
      itemsTitle: "Treatments",
      items: [
        "Anti-aging facials",
        "Lifting effect",
        "Acne, acne-scars and depigmentation treatments",
        "Hydrating facials for dry and/or sensitive skin",
        "Lash lift",
      ],
      benefitsTitle: "Benefits",
      benefits: [
        "Healthy skin acts as a protective barrier against bacteria and chemicals.",
        "A care routine reduces the risk of acne, blackheads, dryness, irritation and premature aging.",
        "Hydrated, clean skin looks smoother, more radiant and healthier.",
      ],
      cta: "Book an aesthetic treatment",
    },
    contact: {
      eyebrow: "Contact",
      title: "We're here to listen",
      desc: "Send us a message or reach out directly on WhatsApp. We'll get back to you as soon as possible.",
      address: "El Pípila 200, Colonia Centro, Pachuca de Soto, Hidalgo, Mexico",
      hoursTitle: "Hours",
      hours: "Mon–Fri 9:00–19:00 · Sat 9:00–14:00",
      whatsapp: "Direct WhatsApp",
      send: "Send message",
      sending: "Sending...",
      msgName: "Your name",
      msgEmail: "Your email",
      msgPhone: "Your phone",
      msgMessage: "Your message",
      sentTitle: "Message sent",
      sentDesc: "Thanks for reaching out.",
    },
    footer: {
      tag: "Caring for your body",
      copy: "All rights reserved.",
    },
    fab: {
      whatsapp: "Chat on WhatsApp",
    },
    specialties: {
      eyebrow: "Conditions we treat",
      title: "Clinical care for the reason behind your visit",
      desc: "We combine chiropractic, physical therapy, rehab and alternative therapies to address common pain conditions at the root.",
      items: [
        { name: "Sciatica", img: "/img/specialties/01_ciatica.png" },
        { name: "Back pain", img: "/img/specialties/02_dolor_espalda.png" },
        { name: "Hip pain", img: "/img/specialties/03_dolor_cadera.png" },
        { name: "Knee pain", img: "/img/specialties/04_dolor_rodilla.png" },
        { name: "Sport injury", img: "/img/specialties/05_lesion_deportiva.png" },
        { name: "Therapies for athletes", img: "/img/specialties/06_terapias_deportistas.png" },
        { name: "Recovery massage", img: "/img/specialties/07_masaje_descarga.png" },
        { name: "Body massage", img: "/img/specialties/08_masaje_corporal.png" },
        { name: "Facial massage", img: "/img/specialties/09_masaje_facial.png" },
        { name: "Bone-setter · Chiropractic adjustments", img: "/img/specialties/10_huesero_quiropractica.png" },
        { name: "Ozone therapy", img: "/img/specialties/11_ozonoterapia.png" },
        { name: "Dry needling", img: "/img/specialties/12_puncion_seca.png" },
        { name: "Neural therapy", img: "/img/specialties/13_terapia_neural.png" },
        { name: "Herbalism · Adaptogens", img: "/img/specialties/14_herbolaria.png" },
        { name: "Reflexology", img: "/img/specialties/15_reflexologia.png" },
        { name: "Cupping", img: "/img/specialties/16_ventosas_cupping.png" },
        { name: "Facial mesotherapy", img: "/img/specialties/09_masaje_facial.png" },
        { name: "Functional medicine", img: "/img/specialties/14_herbolaria.png" },
      ],
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "Answers before your first visit",
      items: [
        {
          q: "Do you treat sciatica and back pain?",
          a: "Yes. We treat sciatica, lower back, hip and knee pain with physical therapy, chiropractic adjustments and rehabilitation. We start with a full assessment and tailor your plan.",
        },
        {
          q: "Do you offer specialized treatments for athletes?",
          a: "Yes. We handle sport injuries with recovery massage, kinesiotaping, dry needling, neural therapy and sport-specific rehab plans.",
        },
        {
          q: "What are the alternative therapies you offer?",
          a: "Ozone therapy, dry needling, neural therapy, herbalism, adaptogens, reflexology and cupping as complementary care for both clinical and wellness goals.",
        },
        {
          q: "What is the difference between a chiropractor and a 'huesero'?",
          a: "'Huesero' is a colloquial term for manual adjustments. At TERAFIQUIRO we practice clinical chiropractic — assessment, precise joint manipulations and therapeutic massage — always evidence-based.",
        },
        {
          q: "Where are you located?",
          a: "We are located in Pachuca de Soto, Hidalgo, Mexico. Book online or contact us on WhatsApp: Physical Therapy/Chiropractic +52 771 214 1634, Alternative Therapies +52 771 161 0609, Aesthetics +52 771 129 0073.",
        },
        {
          q: "What does facial aesthetics include?",
          a: "Anti-aging facials, lifting effect, acne and acne-scar treatments, depigmenting protocols, hydrating facials for dry/sensitive skin, and lash lift. Professional skincare made for you.",
        },
      ],
    },
  },
};

export const TESTIMONIALS = [
  {
    es: { name: "Mariana López", role: "Lumbalgia crónica", text: "Después de tres sesiones empecé a dormir sin dolor. El trato es humano y profesional." },
    en: { name: "Mariana López", role: "Chronic lower back pain", text: "After three sessions I started sleeping pain free. The care is human and professional." },
  },
  {
    es: { name: "Carlos Hernández", role: "Lesión deportiva", text: "Volví a correr en 6 semanas. El plan de rehabilitación fue clave para mi recuperación." },
    en: { name: "Carlos Hernández", role: "Sport injury", text: "I was back running in 6 weeks. The rehab plan was key to my recovery." },
  },
  {
    es: { name: "Ana Sofía Ramírez", role: "Migrañas", text: "Las sesiones quiroprácticas redujeron mis migrañas casi al 100%. Increíble." },
    en: { name: "Ana Sofía Ramírez", role: "Migraines", text: "Chiropractic sessions reduced my migraines almost 100%. Amazing." },
  },
  {
    es: { name: "Jorge Méndez", role: "Hernia cervical", text: "Profesionales con calidad humana. Recuperé mi movilidad sin cirugía." },
    en: { name: "Jorge Méndez", role: "Cervical hernia", text: "Professionals with warmth. I regained my mobility without surgery." },
  },
  {
    es: { name: "Lucía Aguilar", role: "Postura", text: "Mi postura cambió por completo. Recomiendo TERAFIQUIRO con los ojos cerrados." },
    en: { name: "Lucía Aguilar", role: "Posture", text: "My posture changed completely. I recommend TERAFIQUIRO blindly." },
  },
  {
    es: { name: "Diego Torres", role: "Esguince de tobillo", text: "Excelente equipo, espacio impecable y resultados desde la primera semana." },
    en: { name: "Diego Torres", role: "Ankle sprain", text: "Excellent team, impeccable space and results from week one." },
  },
];

export const TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "12:00", "12:30", "15:00", "15:30", "16:00", "16:30",
  "17:00", "17:30", "18:00", "18:30",
];
